module.exports = __webpack_public_path__ + "img/cow1.0eeedef9.png";